import { render, staticRenderFns } from "./TabHistoryDetail.vue?vue&type=template&id=7f96ce28&scoped=true"
import script from "./TabHistoryDetail.vue?vue&type=script&lang=js"
export * from "./TabHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./TabHistoryDetail.vue?vue&type=style&index=0&id=7f96ce28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96ce28",
  null
  
)

export default component.exports